import staticUrl from "../../app/utils/staticPath";

const seasonPlanService = require(`seasonPlanService`);
const modal = require(`modal`);
const loader = require(`loader`);

const seasonPlan = (function() {
  let $sp = $(`#sp-calendar-page`),
    teamID = $sp.attr(`data-team-id`);

  const onboarding = function() {
    const firstVisit = localStorage.getItem(`firstVisit`);

    // Only show onboarding on first visit (using localstorage)
    if (firstVisit === null) {
      localStorage.setItem(`firstVisit`, 1);

      $(`window`).modal({
        confirmText: `View your Season Plan`,
        onboarding: true,
        onboardingItem: [
          {
            img: `${staticUrl()}assets/images/raster/season-plans/sp-onboarding-1.jpg`,
            title: `Welcome to your new Season Plan`,
            content: `<p>We're delighted to have you on board. We hope that by providing you with a tailored Season Plan devised by our qualified experts you can spend less time planning and more time helping your players improve.</p>`,
          },
          {
            img: `${staticUrl()}assets/images/raster/season-plans/sp-onboarding-3.jpg`,
            title: `Invite your Players`,
            content: `<p>Invite your players to join your team and view your season plan. Our simple <a target='_blank' href='/locker/club-management/team-members/${teamID}'>invite system</a> allows players to view all of the drills in the upcoming sessions.</p>`,
          },
          {
            img: `${staticUrl()}assets/images/raster/season-plans/sp-onboarding-2.jpg`,
            title: `Any Questions?`,
            content: `<p>If you have any questions or suggestions on how we can improve Season Plans please email us at <a href='mailto:help@thecoachingmanual.com?subject=Help with Season Plans'>help@thecoachingmanual.com</a> and we'll be happy to help.</p><p><strong>Happy Coaching</strong></p>`,
          },
        ],
        complete () {

        },
      });
    }
  };

  const deleteClick = function() {
    $(`.delete-sp`).on(`click`, function(e) {
      e.preventDefault();

      const clubID = $sp.attr(`data-club-id`);

      $(window).modal({
        confirmText: `Delete Season Plan`,
        title: `Are you sure you want to delete this Season Plan?`,
        content: `<p>Once deleted, all members of your team will no longer be able to access this Season Plan. You will be able to create a new Season Plan - but as Season Plans are tailored the plan that is built might not be the same.</p>`,
        complete() {
          $(`window`).showLoader();
          deleteSeasonPlanService(clubID, teamID, deleteSeasonPlan);
        },
      });
    });
  };

  var deleteSeasonPlan = function(response) {
    if (response.statusCode === 200) {
      $(`window`).notification({
        title: response.message,
        important: true,
      });
    } else {
      $(`window`).notification({
        title: response.message,
        error: true,
      });
    }
  };

  const init = function() {
    if ($sp.length) {
      onboarding();
      deleteClick();
    }
  };

  return {
    init,
  };
}());

seasonPlan.init();



// WEBPACK FOOTER //
// ./library/js/modules/season-plan.js